import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppDispatch } from "../store";
import { api } from "@/utils/api";

// Definimos el tipo de estado para `measurementUnits`
interface MeasurementUnit {
  name: string;
  id: string;
}

interface MeasurementState {
  fetching: boolean;
  array: MeasurementUnit[];
  current: Record<string, any>;
  error?: string;
}

// Estado inicial de `measurementUnits`
const initialState: MeasurementState = {
  fetching: false,
  array: [],
  current: {},
};

const measurementSlice = createSlice({
  name: "measurementUnits",
  initialState,
  reducers: {
    getMeasurementUnits(state) {
      state.fetching = true;
    },
    getMeasurementUnitsSuccess(state, action: PayloadAction<MeasurementUnit[]>) {
      state.fetching = false;
      state.array = action.payload.map((unit) => ({ name: unit.name, id: unit.id }));
    },
    getMeasurementUnitsError(state, action: PayloadAction<string>) {
      state.fetching = false;
      state.error = action.payload;
    },
  },
});

export const {
  getMeasurementUnits,
  getMeasurementUnitsSuccess,
  getMeasurementUnitsError,
} = measurementSlice.actions;
export default measurementSlice.reducer;

// Thunk para realizar la acción de obtener las unidades de medida
export const getUnitsAction = () => async (dispatch: AppDispatch) => {
  dispatch(getMeasurementUnits());
  try {
    const res = await api.get(`${import.meta.env.VITE_APP_BASE_URL}/measurements/parameters/units`);
    dispatch(getMeasurementUnitsSuccess(res.data));
  } catch (err: any) {
    console.error(err);
    dispatch(getMeasurementUnitsError(err.response?.message || "Error desconocido"));
  }
};